/**
 * Created by saeed on 12/12/2016.
 */

angular.module('tikonApp').directive('eoScheduleStartEndDateValidator', ['AlertService', 'ScheduleValidator', '$timeout', function (alertService, ScheduleValidator, $timeout) {

    return {
        restrict: 'E',
        scope: {startDate: '<', endDate: '<', serviceItemId: '<', scheduleInfoId: '<', targetElementId: '@'},

        link: function (scope, elm, attrs, ctrl) {
            $timeout(function () {
                var vm = this;

                //validation message to show
                var message1 = 'messages.schedule.ScheduleStartEndDateValidator.startDateIsBigger';
                var message2 = 'messages.schedule.ScheduleStartEndDateValidator.conflictWithOtherSchedules';
                elm = $('#' + scope.targetElementId);


                //adding validation message for element
                //    validationService.addMessage();
                scope.$watchGroup(['startDate', 'endDate'], function (newValues, oldValues, scope) {
                    //

                    var startDate = new Date(newValues[0]);
                    var endDate = new Date(newValues[1]);


                    //   scope.editForm.fromDate.$setValidity("eoScheduleStartEndDateValidator", true);
                    if (startDate && endDate) {

                        if (startDate >= endDate) {
                            alertService.showValidationMessage(elm, message1);
                        } else {
                            //    validationService.hide();
                            checkDatesWithOtherSchedules(startDate, endDate);


                        }
                    }


                });

                function checkDatesWithOtherSchedules(startDate, endDate) {
                    if (scope.serviceItemId && scope.scheduleInfoId)
                        ScheduleValidator.scheduleStartEndDateValidator(startDate, endDate, scope.serviceItemId, scope.scheduleInfoId).get(
                            function (result) {

                                if (result.data.valid) {

                                } else {
                                    alertService.showValidationMessage(elm, message2);
                                }
                            }
                        );
                }

                //validator function


            });

        }
    };
}]);
